import BulkbonusesResource from "./bulkbonuses.resource";

const bulkbonusesModule = angular
  .module("app.resources.bulkbonuses", [])
  .service("Bulkbonuses", BulkbonusesResource);

export default bulkbonusesModule;



// WEBPACK FOOTER //
// ./src/resources/bulkbonuses/bulkbonuses.module.js